import { createSelector } from "reselect"
import { map, get, pickBy, reduce, chain } from "lodash"
import { computeCategoryItemsSubset, computePerformanceData, computeNonZerosKeys } from "helpers/analyze"
import { findTradeStatus } from "helpers/drift"
import { getSelectedDate } from "modules/factor-trends/selectors/dates"
import { getComputedFactors, getAllCategoryItems, getOrderedCategoryItems } from "./items"
import { getPerformanceHistory, getFactorsPerformance } from "./performance"

export const getData = createSelector(
  [getComputedFactors, getPerformanceHistory],
  computePerformanceData,
)

export const getNonZerosKeys = createSelector(
  [getData],
  computeNonZerosKeys,
)

export const getFilteredData = createSelector(
  [getData, getNonZerosKeys],
  (data, keys) => map(data, item => pickBy(item, (item, key) => keys[key])),
)

export const getCategoryItemsSubset = createSelector(
  [getOrderedCategoryItems, getNonZerosKeys],
  computeCategoryItemsSubset,
)

export const getDisplayCategories = createSelector(
  [getComputedFactors, getNonZerosKeys],
  (factors, keys) => chain(factors)
    .filter(item => keys[item.id])
    .map(item => [item.category, item.selectedView])
    .flatten()
    .compact()
    .uniq()
    .value(),
)

const getFactorsNormalizedReturn = createSelector(
  [getFactorsPerformance, getSelectedDate],
  (factors, selectedDate) => reduce(factors, (acc, { id, performance }) => ({
    ...acc,
    [id]: chain(performance)
      .find(({ date }) => date === selectedDate)
      .get("normalizedReturn")
      .value(),
  }), {}),
)

export const getDriftArrows = createSelector(
  [getAllCategoryItems, getFactorsNormalizedReturn],
  (items, factors) => reduce(items, (acc, item) => ({
    ...acc,
    [item.id]: findTradeStatus(get(factors, item.id)),
  }), {}),
)
